import React from "react";
import Typography from "@mui/material/Typography";
import "./header.css";

const Header = () => {
  return (
    <div className="container--title">
      <Typography variant="h5">
        <strong>CAPITAL QUIZ 1.1</strong>
      </Typography>
    </div>
  );
};

export default Header;
